/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyDevice} from '../api'

export const useMutationVerifyDevice = createReactQueryMutationHook('verifyDevice', verifyDevice)
